<template>
  <div v-if="parution">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('editCheminFer.title', { code: parution.code }) }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button @click="save()" class="button is-addOrEdit">
              {{ $t('general.button.sauvegarder') }}
            </button>
            <button class="button is-bottom-left has-text-left"
                    @click="checkPermissions(permsParution.editer)
                      ? popUpEdition = true
                      : showPopUpPermission()">
              <b-icon icon="file-download" type="is-default"></b-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <error-msg-component
      v-if="error"
      :messages="messages"
      :error="error"
      :champs-vide="champsVide"
      :messages-champs-vide="messagesChampsVide"
      @close="error = $event"
      class="mgt-20px"
      title="general.problemOccurred"
      withEmplyFields/>
    <infos-parution :parution="parution"/>
    <div class="columns is-multiline is-centered">
      <div class="column is-12 mgt-20px">
        <b-field class="is-pulled-left">
          <qd-radio-button
              v-model="onePageView"
              :native-value="true"
              type="is-primary">
              <b-tooltip
                type="is-primary"
                position="is-top"
                :label="$t('editCheminFer.monoPage')">
                  <b-icon class="mgh-0" icon="square"></b-icon>
              </b-tooltip>
          </qd-radio-button>
          <qd-radio-button
              v-model="onePageView"
              :native-value="false"
              type="is-primary">
              <b-tooltip
                type="is-primary"
                position="is-top"
                :label="$t('editCheminFer.multiPage')">
                  <b-icon class="mgh-0" icon="view-grid"></b-icon>
              </b-tooltip>
          </qd-radio-button>
        </b-field>
      </div>
      <div
      v-if="onePageView"
      class="column is-8 overflow-x-auto"
      ref="pageContainer">
        <div
            class="columns is-justify-content-space-between is-vcentered is-multiline">
          <div class="column is-narrow">
            <div class="columns is-justify-content-end">
              <div class="column is-narrow pdr-10px">
                <div
                  class="button"
                  @click="zoomPage(false)">
                  <b-icon icon="magnify-minus" class="is-cursor-pointer"></b-icon>
                </div>
              </div>
              <div class="column is-narrow pdl-20px">
                <div
                  class="button"
                  @click="zoomPage(true)">
                  <b-icon icon="magnify-plus" class="is-cursor-pointer"></b-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-narrow columns is-justify-content-space-between
            is-vcentered is-marginless pd-0">
            <div class="column is-narrow">
              <div class="button" @click="previous()">
                <b-icon icon="arrow-left" class="is-cursor-pointer"></b-icon>
              </div>
            </div>
            <div class="column is-narrow has-text-centered has-text-weight-bold">
              {{ $t('editCheminFer.titleCurrentPage',
                {pageNumber: pageNumber, pageMax: getNumberPage}) }}
            </div>
            <div class="column is-narrow">
              <div class="button" @click="next()">
                <b-icon icon="arrow-right" class="is-cursor-pointer"></b-icon>
              </div>
            </div>
          </div>
          <div class="column is-narrow">
            <div class="button" @click="addEncartReserved()">
              {{ $t('editCheminFer.actions.reserverEncart') }}
            </div>
          </div>
        </div>
        <div class="has-text-centered is-italic">
          {{ getPageInformation(pageNumber) }}
        </div>
        <div
              class="is-fullwidth is-flex is-justify-content-center"
              :style="`
                scale: ${scale / 100};
                transform-origin: top;
              `">
          <div :style="getStyleOfPageTemplate(pageNumber)" class="mgt-10px">
            <div :style="getStyleOfPageTemplateUtile(pageNumber)" class="is-relative">
              <bloc-encart-chemin-fer
                v-for="(encart) in getFilteredEncartOfPage(pageNumber)"
                :key="encart.id"
                :encart="encart"
                :page="getPageByOrdre(pageNumber)"
                :lignesCommandes="parution.lignesCommandes"
                :url="getUrl(encart.ligneRegroupementId)"
                @deleteEncart="deleteEncart(encart.ligneRegroupementId, encart.id)"
                @editEncart="editEncart(encart)">
              </bloc-encart-chemin-fer>
            </div>
          </div>
        </div>
      </div>
      <div
        class="column is-12 columns is-multiline is-centered"
        v-else>
        <div class="column is-12 mg-0 mgt-3 pd-0">
          <div
            class="button mgr-10px"
            @click="zoomPage(false)">
              <b-icon icon="magnify-minus" class="is-cursor-pointer"></b-icon>
          </div>
          <div
            class="button mgl-20px"
            @click="zoomPage(true)">
              <b-icon icon="magnify-plus" class="is-cursor-pointer"></b-icon>
          </div>
        </div>
        <div
          class="column is-narrow mg-20px"
          v-for="page in parution.pages"
          :key="page.id"
          :style="`
              height: ${(page.hauteur * (scale / 100)) + 15}mm;
              width: ${page.largeur * (scale / 100)}mm`">
          <div
            class="is-flex is-justify-content-center is-align-items-flex-end"
            style="height: 15mm;">
            <div class="has-text-centered">
              <strong>{{ `Page ${page.ordre}` }}</strong>
              <span v-if="scale > 20" class="is-italic">
                 - {{ getPageInformation(page.ordre) }}
              </span>
            </div>
          </div>
          <div
                class="is-fullwidth is-flex is-justify-content-center"
                :style="`scale: ${scale / 100};
                        transform-origin: center top;`">
            <div :style="getStyleOfPageTemplate(page.ordre)" class="mgt-10px">
              <div :style="getStyleOfPageTemplateUtile(page.ordre)" class="is-relative">
                <bloc-encart-chemin-fer
                  v-for="(encart) in getFilteredEncartOfPage(page.ordre)"
                  :key="encart.id"
                  :encart="encart"
                  :page="page"
                  :lignesCommandes="parution.lignesCommandes"
                  :url="getUrl(encart.ligneRegroupementId)"
                  :isEditable="false">
                </bloc-encart-chemin-fer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="onePageView" class="column is-4">
        <div class="columns is-multiline is-vcentered">
          <div class="column is-7 has-text-weight-bold">
            {{ $t(`editCheminFer.titleListeEncart.${filter}`) }}
          </div>
          <div class="column is-5">
            <b-select expanded v-model="filter">
              <option
                v-for="action in actions"
                :key="action.key"
                :value="action.key">
                {{ $t(action.libelle) }}
              </option>
            </b-select>
          </div>
          <div
            class="overflow-y-auto full-width"
            :style="`max-height: ${this.pageContainer.height};`">
            <div
              v-for="(ligne, index) in getLigneCommandeFiltred"
              :key="index"
              class="column is-12">
              <infos-encart-ligne-commande
                :ligne="ligne"
                :url="getUrl(ligne.id)"
                :hasEncartPlace="!!hasEncartPlace(ligne.id)"
                @addEncart="addEncart(ligne)"
                @deleteEncart="deleteEncart(ligne.id)"
                @voirPage="voirPage(ligne.id)"
              />
            </div>
            <div
              v-if="getLigneCommandeFiltred.length === 0"
              class="has-text-centered has-background-white-bis column is-12 mgt-10px">
              <h1 class="title is-size-6">
                {{ $t('editCheminFer.plusEncartAPlacer') }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="popUpEditEncartCheminFer"
      class="modal"
      has-modal-card>
      <pop-up-edit-encart-chemin-fer
        v-if="encartSelected"
        :value="encartSelected"
        @save="updateEncartCheminFer"/>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="{}"
        :choiceEdition="listeChoiceEdition"
        @editionChoose="editionCheminDeFer">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { sauvegardeCheminFer, getCheminFer } from '@/api/presse/parution';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import Breadcrumb from '@/components/general/breadcrumb';
import PopUpEditEncartCheminFer from '@/components/presse/parution/cheminFer/p_editEncartCheminFer';
import InfosParution from '@/components/presse/parution/cheminFer/infosParution';
import InfosEncartLigneCommande from '@/components/presse/parution/cheminFer/infosEncartLigneCommande';
import BlocEncartCheminFer from '@/components/presse/parution/cheminFer/blocEncartCheminFer';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';
import { PIECE_JOINTE_TYPE_LOGO } from '@/configuration/general/pieceJointeConf';
import * as cheminFerConfig from '@/configuration/presse/parution/cheminFerConfig';
import messageSucces from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/presse/parution/translatorCheminFer';
import genererEncartCheminFer from '@/services/presse/parution/genererEncartCheminFer';
import { PARUTION } from '@/configuration/presse/permissionsPresseConf';
import {
  TYPE_EDITION_CHEMIN_FER_SANS_PAGE_VIDE,
  LISTE_CHOICE_EDITION_PARUTION,
} from '@/configuration/presse/parution/parutionConfig';
import edition from '@/api/edition';
import messageErreur from '@/services/general/messageErreur';
import PopUpEdition from '@/components/factures/p_edition';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'MCheminFer',
  components: {
    Breadcrumb,
    PopUpEditEncartCheminFer,
    InfosParution,
    InfosEncartLigneCommande,
    BlocEncartCheminFer,
    ErrorMsgComponent,
    PopUpEdition,
  },
  data() {
    return {
      parution: null,
      scale: cheminFerConfig.SCALE_MAX,
      pageNumber: 1,
      encartPlace: [],
      pjLigneCommande: [],
      filter: cheminFerConfig.VIEW_DISPO,
      actions: cheminFerConfig.ACTIONS_VIEWS,
      permsParution: PARUTION,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      encartSelected: null,
      popUpEditEncartCheminFer: false,
      pageContainer: { width: 100, height: 100 },
      popUpEdition: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_PARUTION.filter(el => el.afficherSurCheminDeFer),
      onePageView: true,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeParution.breadcrumb.liste'), route: { name: 'l.presse.parution' }, isActive: false },
        { title: this.$t('editCheminFer.breadcrumb.edit', { code: this.parution.code }), route: { name: '' }, isActive: true },
      ];
    },
    getNumberPage() {
      return Math.max(...this.parution.pages.map((el) => el.ordre));
    },
    getMinNumberPage() {
      return Math.min(...this.parution.pages.map((el) => el.ordre));
    },
    getLigneCommandeFiltred() {
      return this.parution.lignesCommandes.filter((ligne) => {
        if (this.filter === cheminFerConfig.VIEW_ALL) return true;
        if (this.filter === cheminFerConfig.VIEW_PLACER) {
          const encartPlace = this.encartPlace.find(e => e.ligneRegroupementId === ligne.id);
          return encartPlace !== undefined;
        }
        if (this.filter === cheminFerConfig.VIEW_OF_PAGE) {
          const currentPage = this.getPageByOrdre(this.pageNumber);
          const encartPlace = this.encartPlace
            .find(e => e.pageParutionId === currentPage.id && e.ligneRegroupementId === ligne.id);
          return encartPlace !== undefined;
        }
        if (this.filter === cheminFerConfig.VIEW_DISPO) {
          const currentPage = this.getPageByOrdre(this.pageNumber);
          const isPlace = this.encartPlace.find(e => e.ligneRegroupementId === ligne.id);
          if (isPlace) return false;
          if (ligne.ligneEncart.largeur > currentPage.largeurUtile
            || ligne.ligneEncart.hauteur > currentPage.hauteurUtile) {
            return false;
          }
          const ratioOfPage = this.encartPlace
            .filter(e => e.pageParutionId === currentPage.id)
            .map(encart => encart.ratio)
            .reduce((total, ratio) => total + ratio, 0);
          if ((ratioOfPage + ligne.ligneEncart.ratio) <= currentPage.surface.ratio) return true;
        }
        return false;
      });
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    getFilteredEncartOfPage(number) {
      const currentPage = this.getPageByOrdre(number);
      return this.encartPlace.filter((el) => {
        return el.pageParutionId === currentPage.id;
      });
    },
    getPageInformation(number) {
      const currentPage = this.getPageByOrdre(number);
      if (!currentPage) return '';
      return `${currentPage.surface.libelle} - ${currentPage.emplacement.libelle} - ${currentPage.couleurEncart.libelle} - H${currentPage.hauteur} - L${currentPage.largeur} - H.U${currentPage.hauteurUtile} - L.U${currentPage.largeurUtile}`;
    },
    getStyleOfPageTemplate(number) {
      const page = this.getPageByOrdre(number);
      if (!page) return '';
      return `
      border: solid 1px black;
      height: ${page.hauteur}mm;
      max-width: ${page.largeur}mm!important;
      width: ${page.largeur}mm!important;`;
    },
    getStyleOfPageTemplateUtile(number) {
      const page = this.getPageByOrdre(number);
      if (!page) return '';
      return `
      border: solid 1px black;
      height: ${page.hauteurUtile}mm;
      max-width: ${page.largeurUtile}mm!important;
      background-color: white;
      width: ${page.largeur}mm!important;
      margin: ${(page.hauteur - page.hauteurUtile) / 2}mm ${(page.largeur - page.largeurUtile) / 2}mm!important;`;
    },
    getUrl(ligneCommandeId) {
      const image = this.pjLigneCommande.find((pj) => pj.elementId === ligneCommandeId);
      if (!image) return null;
      return image.cheminMin ? image.cheminMin : image.chemin;
    },
    getPageByOrdre(ordre) {
      return this.parution.pages.find((page) => page.ordre === ordre);
    },
    addEncartReserved() {
      const currentPage = this.getPageByOrdre(this.pageNumber);
      const encartCheminFer = genererEncartCheminFer(currentPage.id);
      encartCheminFer.libelleRegroupement = this.$t('editCheminFer.encartReserve');
      this.encartPlace.push(encartCheminFer);
    },
    addEncart(ligneCommande) {
      const currentPage = this.getPageByOrdre(this.pageNumber);

      if (ligneCommande.ligneEncart.largeur > currentPage.largeurUtile
        || ligneCommande.ligneEncart.hauteur > currentPage.hauteurUtile) return;

      const allRatioOfPage = this.encartPlace
        .filter(e => e.pageParutionId === currentPage.id)
        .map(e => e.ratio);
      if (allRatioOfPage.length > 0) {
        const totalRatioOfPage = allRatioOfPage.reduce((acc, val) => acc + val);
        if (totalRatioOfPage + ligneCommande.ligneEncart.ratio > currentPage.surface.ratio) return;
      }

      if (this.hasEncartPlace(ligneCommande.id)) return;

      this.encartPlace.push(genererEncartCheminFer(currentPage.id, ligneCommande));
    },
    hasEncartPlace(ligneCommandeId) {
      return this.encartPlace.find(e => e.ligneRegroupementId === ligneCommandeId);
    },
    deleteEncart(ligneCommandeId, encartId) {
      const encartIndex = this.encartPlace
        .findIndex(e => e.ligneRegroupementId === ligneCommandeId
          && (!encartId || e.id === encartId));
      if (encartIndex !== -1) this.encartPlace.splice(encartIndex, 1);
    },
    previous() {
      if (this.pageNumber - 1 <= this.getMinNumberPage) this.pageNumber = this.getMinNumberPage;
      else this.pageNumber -= 1;
      this.refreshScaleFromPage();
    },
    next() {
      if (this.pageNumber + 1 >= this.getNumberPage) this.pageNumber = this.getNumberPage;
      else this.pageNumber += 1;
      this.refreshScaleFromPage();
    },
    zoomPage(plus) {
      if (plus && this.scale + 10 <= 100) this.scale += 10;
      if (!plus && this.scale - 10 > 10) this.scale -= 10;
    },
    refreshScaleFromPage() {
      const currentPage = this.getPageByOrdre(this.pageNumber);
      if ((currentPage.largeur * cheminFerConfig.COEFFICIENT_DIMENSION)
      > this.pageContainer.width) {
        const scale = this.pageContainer.width * 100
        / (currentPage.largeur * cheminFerConfig.COEFFICIENT_DIMENSION);
        this.scale = scale - scale % 10;
      }
    },
    voirPage(ligneCommandeId) {
      const encartPlace = this.hasEncartPlace(ligneCommandeId);
      if (!encartPlace) return;
      const page = this.parution.pages.find(p => p.id === encartPlace.pageParutionId);
      if (page) this.pageNumber = page.ordre;
    },
    updateEncartCheminFer(encartCheminFer) {
      const index = this.encartPlace.findIndex(e => e.id === encartCheminFer.id);
      if (index !== -1) {
        this.encartPlace.splice(index, 1, encartCheminFer);
      }
      this.popUpEditEncartCheminFer = false;
      this.encartSelected = null;
    },
    async editionCheminDeFer(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const editionInput = {
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: {
            societeId: this.societeActiveId,
          },
          ids: [this.$route.params.parutionId],
        };
        if (donnees.typeDonnee === TYPE_EDITION_CHEMIN_FER_SANS_PAGE_VIDE) {
          editionInput.parametresAdditionnels.sansPageVide = 'True';
        }
        const response = await edition(editionInput);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    editEncart(encart) {
      this.encartSelected = encart;
      this.popUpEditEncartCheminFer = true;
    },
    async save() {
      this.error = false;
      this.champsVide = [];
      this.messages = [];
      this.messagesChampsVide = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        const encarts = cloneDeep(this.encartPlace);
        encarts.forEach((page) => {
          if (!page.isCreate) return;
          delete page.isCreate;
          delete page.id;
        });
        await sauvegardeCheminFer({ encarts, parutionId: this.parution.id });
        await this.initDataCheminFer();
        messageSucces(this.$i18n.t('editCheminFer.notifications.successSauvegarde'));
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          return;
        }
        throw e;
      }
    },
    async initDataCheminFer() {
      const { parutionId } = this.$route.params;
      const parution = (await getCheminFer(parutionId)).data.result;
      parution.pages.sort((a, b) => a.ordre - b.ordre);
      parution.lignesCommandes.forEach((ligne) => {
        ligne.open = true;
      });
      const encartPlace = parution.pages.map(p => p.encarts).flat();
      encartPlace.forEach(e => {
        delete e.ligneEncart;
        delete e.ligneRegroupement;
      });
      this.encartPlace = encartPlace;
      parution.pages.forEach(e => {
        delete e.encarts;
      });
      this.parution = parution;
      if (this.getPageByOrdre(this.pageNumber) === undefined && this.parution.pages.length > 0) {
        this.pageNumber = this.parution.pages[0].ordre;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.initDataCheminFer();
      const pjLigneCommande = (await pGetAllPieceJointe({
        elementsId: this.parution.lignesCommandes.map(l => l.id),
        placeType: PIECE_JOINTE_TYPE_LOGO,
      })).data.result.items;
      this.pjLigneCommande = pjLigneCommande;
      this.setInformationPage(this.$t('pagePresse.cheminFer.modification', { code: this.parution.code }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
    if (this.$refs.pageContainer) {
      this.pageContainer = {
        width: this.$refs.pageContainer.clientWidth,
        height: this.$refs.pageContainer.clientHeight,
      };
    }
    this.refreshScaleFromPage();
  },
};
</script>
